export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this a physical product?',
    answer: 'No. Horse Riding Instructor Pro™ is 100% digital.',
  },
  {
    question: 'Is this for beginner instructors?',
    answer:
      'It is designed especially for experienced riding instructors who want to reduce preparation time and work with more organized material.',
  },
  {
    question: 'Is it mostly theory?',
    answer:
      'No. The focus is ready-to-use lessons, exercises, arena setups, assessments, progression tools, templates, and professional instructor resources.',
  },
  {
    question: 'Can I adapt the material to different riders and horses?',
    answer:
      'Yes. The system includes regressions, progressions, alternative formats, and adaptation tools.',
  },
  {
    question: 'Does it work for private and group lessons?',
    answer:
      'Yes. The system includes resources for individual, semi-private, and group teaching.',
  },
  {
    question: 'How will I receive it?',
    answer: 'Immediately after payment by digital delivery.',
  },
  {
    question: 'Does it include complete lesson plans?',
    answer:
      'Yes. Module 1 includes ready-to-teach lesson structures for different rider levels and technical objectives, so you can take them straight into the arena.',
  },
  {
    question: 'Can I print the arena cards, planners and trackers?',
    answer:
      'Yes. The visual arena layouts, lesson planners, observation sheets and progress trackers are made to be printed for the arena or personalized and shared digitally with your riders.',
  },
  {
    question: 'Will it work if I teach in a small arena or outdoor space?',
    answer:
      'Yes. The Arena Setup & Exercise Design Toolkit™ includes limited-space adaptations, setup variations, and reusable structures for different arena sizes and surfaces.',
  },
  {
    question: 'How long do I keep access, and what if I need help?',
    answer:
      'Your access does not expire — download everything and keep using it season after season. If you have any question about your delivery or the resources, contact support at kitonline27@gmail.com.',
  },
]
